export const onRouteUpdate = ({ location, prevLocation }) => {
    if (prevLocation && location.pathname !== prevLocation.pathname) {
        if (typeof window !== "undefined") {
            document.body.classList.remove("menu-open")
        }

        setTimeout(() => {
            if (typeof window !== "undefined") {
                if (window.lenis) {
                    window.lenis.scrollTo(0, { immediate: true })
                } else {
                    window.scrollTo(0, 0)
                }
            }
        }, 100)
    }
}

export const onInitialClientRender = () => {
    if (typeof window !== "undefined") {
        window.scrollTo(0, 0)
        document.body.style.backgroundColor = "#1b1b1b"
    }
}

export const onPreRouteUpdate = ({ location, prevLocation }) => {
    if (typeof window !== "undefined" && prevLocation && location.pathname !== prevLocation.pathname) {
        document.body.style.backgroundColor = "#1b1b1b"
    }
}

export const onRouteUpdateDelayed = ({ location, prevLocation }) => {
    if (typeof window !== "undefined" && prevLocation && location.pathname !== prevLocation.pathname) {
        setTimeout(() => {
            document.body.style.backgroundColor = ""
        }, 600)
    }
}
